import { addDays, format, isAfter, isBefore, parse } from "date-fns"

export interface ParsedDate {
  date: Date
  year: number
  month: number
  day: number
}

export const parseDate = (date: any): ParsedDate => {
  if (typeof date === "string") {
    const parsed = parse(date, "yyyy-MM-dd", new Date())
    return {
      date: new Date(parsed),
      year: parsed.getFullYear(),
      month: parsed.getMonth(),
      day: parsed.getDate(),
    }
  } else {
    return {
      date: date,
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate(),
    }
  }
}

export const isSameDate = (date1: any, date2: any): boolean => {
  if (!date1 || !date2) return false
  const { year: year1, month: month1, day: day1 } = parseDate(date1)
  const { year: year2, month: month2, day: day2 } = parseDate(date2)
  return year1 === year2 && month1 === month2 && day1 === day2
}

/**
 * Format date as YYYY-MM-DD for comparison and storage
 */
export const toDateString = (date: any): string => {
  return format(date.date || date, "yyyy-MM-dd")
}

/**
 * Format day name (e.g., "Mon")
 */
export const formatDayName = (date: any): string => {
  return format(date.date || date, "EEE")
}

/**
 * Format day number (e.g., "1")
 */
export const formatDayNumber = (date: any): string => {
  return format(date.date || date, "d")
}

/**
 * Format month (e.g., "Jan")
 */
export const formatMonth = (date: any): string => {
  return format(date.date || date, "MMM")
}

/**
 * Format date as a string using a specific format
 */
export const formatFullDate = (date: any): string => {
  return format(date.date || date, "EEEE, MMMM d, yyyy")
}

/**
 * Generate a range of dates between start and end (inclusive)
 */
export const generateDateRange = (_startDate: any, _endDate: any): string[] => {
  const dates: string[] = []
  let currentDate = new Date(_startDate.date || _startDate)
  const endDate = new Date(_endDate.date || _endDate)

  while (
    isBefore(currentDate, endDate) ||
    format(currentDate, "yyyy-MM-dd") === format(endDate, "yyyy-MM-dd")
  ) {
    dates.push(toDateString(currentDate))
    currentDate = addDays(currentDate, 1)
  }

  return dates
}

export const addDaysToDate = (date: any, days: number): Date => {
  return addDays(date.date || date, days)
}

export const isBeforeDate = (date1: any, date2: any): boolean => {
  return isBefore(date1.date || date1, date2.date || date2)
}

export const isAfterDate = (date1: any, date2: any): boolean => {
  return isAfter(date1.date || date1, date2.date || date2)
}
